import {
  getModulePath,
  LEAGUE_MODULE_NAMES,
  overwriteRoutePaths,
} from "@leagueplatform/core";
import { RouteObject } from "@leagueplatform/routing";
import { HealthJourneyRoutes } from "@leagueplatform/health-journey";
import { AuthViewLogin, AuthViewLogout } from "pages/auth/auth.pages";
import { APP_MANAGED_ROUTES } from "common/app-managed-routes";
import { PreLoginLandingPage } from "pages/pre-login-landing/pre-login-landing.page";
import { PageNotFound } from "pages/page-not-found.page";
import { HomePage } from "pages/home/home.page";
import { AuthSessionContainer } from "components/auth-session-container/auth-session-container";

// Define League route config override
const leagueRoutesOverride = {
  [LEAGUE_MODULE_NAMES.assessment]: "/member/health-profile/questions",
  [LEAGUE_MODULE_NAMES.healthProfile]: "/member/health-profile",
  [LEAGUE_MODULE_NAMES.healthNeedPages]: "/health-need",
  [LEAGUE_MODULE_NAMES.onboarding]: "/onboarding",
  [LEAGUE_MODULE_NAMES.aboutMe]: "/member/about-me",
};

overwriteRoutePaths(leagueRoutesOverride);

export const appRoutes: RouteObject[] = [
  {
    path: `${APP_MANAGED_ROUTES.SIGN_IN}/*`,
    element: <AuthViewLogin />,
  },
  {
    path: `${APP_MANAGED_ROUTES.SIGN_OUT}/*`,
    element: <AuthViewLogout />,
  },
  {
    path: APP_MANAGED_ROUTES.LANDING_PAGE,
    element: <PreLoginLandingPage />,
  },
  {
    element: <AuthSessionContainer />,
    children: [
      {
        path: APP_MANAGED_ROUTES.HOME,
        element: <HomePage />,
      },
      ...[
        `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}/*`,
        `${getModulePath(LEAGUE_MODULE_NAMES.healthPrograms)}/*`,
        `${getModulePath(LEAGUE_MODULE_NAMES.healthProgress)}/*`,
        `${getModulePath(LEAGUE_MODULE_NAMES.healthJourneyHistory)}/*`,
        `${getModulePath(LEAGUE_MODULE_NAMES.careLibrary)}/*`,
      ].map((path) => ({
        path,
        element: <HealthJourneyRoutes />, // Lazy loading is not used here due to Journey NodeRenderers required on the Homepage
      })),
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.careCollections)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/care-collections"))
            .CareCollectionsRoutes,
        }),
      },
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.careDiscovery)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/care-discovery"))
            .CareDiscoveryRoutes,
        }),
      },
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.healthNeedPages)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/care-collections"))
            .HealthNeedPages,
        }),
      },
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.healthProfile)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/health-profile"))
            .HealthProfileRoutes,
        }),
      },
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.aboutMe)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/about-me")).AboutMeRoutes,
        }),
      },
      {
        path: `${getModulePath(LEAGUE_MODULE_NAMES.messaging)}/*`,
        lazy: async () => ({
          Component: (await import("@leagueplatform/messaging"))
            .MessagingRoutes,
        }),
      },
      {
        path: "/*",
        element: <PageNotFound />,
      },
      {
        path: "/masonry/:version/:id/*",
        lazy: async () => ({
          Component: (await import("@leagueplatform/masonry"))
            .GenericMasonryPage,
        }),
      },
    ],
  },
];
